<ng-container *transloco="let t;">
    <div class="content-wrapper container-xxl p-0">
        <div>
            <!-- Horizontal Wizard -->
            <section class="horizontal-wizard mb-0 ">

                <div #stepper id="stepper" class="bs-stepper horizontal-wizard-example center-half-page">
                    <div class="bs-stepper-header">
                        <div class="step" data-target="#user-profile" [class.completed]="currentStepIndex > 0">
                            <button class="step-trigger">
                            </button>
                        </div>
                        <div class="step" data-target="#tell-us-about-you">
                            <button class="step-trigger">
                            </button>
                        </div>
                    </div>
                    <button class="back-arrow" (click)="horizontalWizardStepperPrevious()"
                        [disabled]="currentStepIndex === 0" [hidden]="currentStepIndex === 0">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="15 18 9 12 15 6"></polyline>
                        </svg>
                    </button>
                    <div class="bs-stepper-content center-page-items">
                        <form [formGroup]="invitedOnboardingForm" class="form-container">
                            <div id="user-profile" class="content">
                                <app-onboarding-user-profile
                                    [userProfileForm]="invitedOnboardingForm.get('userProfile')"
                                    [isInvitedOnboarding]="true"
                                    [inviteFormDisabled]="inviteFormDisabled"
                                    (continueClicked)="horizontalWizardStepperNext()"></app-onboarding-user-profile>
                            </div>
                            <div id="tell-us-about-you" class="content">
                                <app-onboarding-tell-us-about-you
                                    [tellUsAboutYouForm]="invitedOnboardingForm.get('tellUseAboutYourself')"
                                    (workTypeSelected)="onBoardingSubmit()"></app-onboarding-tell-us-about-you>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
            <!--/ Horizontal Wizard -->
        </div>
    </div>
</ng-container>